import { render } from "./Delegate.vue?vue&type=template&id=2b893cb7"
import script from "./Delegate.vue?vue&type=script&lang=js"
export * from "./Delegate.vue?vue&type=script&lang=js"
script.render = render

export default script